import { IconDefinition } from '@ant-design/icons-angular';

// custom SVG icons (outline theme is most common)
export const customIcons: IconDefinition[] = [
  {
    // register the exact key the nz-icon component will request (suffix -o for outline)
    name: 'diameter',
    theme: 'outline',
    icon: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="300" fill="none" stroke="currentColor" stroke-width="72"/><line x1="100" y1="900" x2="924" y2="100" stroke="currentColor" stroke-width="72" stroke-linecap="round"/></svg>`,
  },
  {
    // weaving machine set / loom harness
    name: 'machine-set',
    theme: 'outline',
    icon: `<svg viewBox="0 0 1024 1024"><rect x="150" y="200" width="724" height="80" fill="none" stroke="currentColor" stroke-width="60"/><rect x="150" y="380" width="724" height="80" fill="none" stroke="currentColor" stroke-width="60"/><rect x="150" y="560" width="724" height="80" fill="none" stroke="currentColor" stroke-width="60"/><rect x="150" y="740" width="724" height="80" fill="none" stroke="currentColor" stroke-width="60"/></svg>`,
  },
  {
    name: 'weight-scale',
    theme: 'outline',
    icon: `<svg viewBox="0 0 1024 1024" fill="none" stroke="currentColor" stroke-width="30" stroke-linecap="round" stroke-linejoin="round">
      <circle fill="none" stroke="currentColor" stroke-width="60" cx="572" cy="250" r="148"></circle>
      <circle fill="none" stroke="currentColor" stroke-width="50" cx="572" cy="250" r="60"></circle>
      <path fill="none" stroke="currentColor" stroke-width="84" d="
        M 320 400
        L 824 400
        Q 860 400 852 436
        L 938 924
        Q 946 964 906 964
        L 228 964
        Q 188 964 196 924
        L 282 436
        Q 290 400 320 400
        Z
      "></path>
    </svg>`,
  },
  {
    name: 'fabric',
    theme: 'outline',
    icon: `<svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="diagonalStripes" patternUnits="userSpaceOnUse" width="26" height="16" patternTransform="rotate(45)">
          <rect width="8" height="16" fill="currentColor"/>
        </pattern>
      </defs>
      <rect x="123" y="40" width="110" height="176" fill="url(#diagonalStripes)" stroke="currentColor" stroke-width="12" stroke-linejoin="round" />
      <rect x="30" y="30" width="100" height="196" rx="40" ry="40" fill="none" stroke="currentColor" stroke-width="12"/>
      <rect x="45" y="160" width="70" height="60" rx="30" ry="30" fill="none" stroke="currentColor" stroke-width="12"/>
      <rect x="65" y="182" width="30" height="16" fill="currentColor"/>
    </svg>`,
  },
  {
    name: 'catalog',
    theme: 'outline',
    icon: `<svg viewBox="12 20 230 230" xmlns="http://www.w3.org/2000/svg">
      <path d="M26 70 Q80 40 120 70 L120 220 Q80 200 26 220 Z" fill="none" stroke="currentColor" stroke-width="12" stroke-linejoin="round"/>
      <path d="M230 70 Q176 40 136 70 L136 220 Q176 200 230 220 Z" fill="none" stroke="currentColor" stroke-width="12" stroke-linejoin="round"/>
      <line x1="128" y1="70" x2="128" y2="220" stroke="currentColor" stroke-width="8" stroke-linecap="round"/>
    </svg>`,
  },
  {
    name: 't-shirt',
    theme: 'outline',
    icon: `<svg width="256" height="256" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
      <path d="M88 60 Q128 60 168 60 L210 80 L190 120 L170 110 L170 200 L86 200 L86 110 L66 120 L46 80 Z" fill="none" stroke="currentColor" stroke-width="12" stroke-linejoin="round" stroke-linecap="round"/>
      <path d="M108 66 Q128 96 148 66" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
    </svg>`,
  },
  {
    name: 'quotation',
    theme: 'outline',
    icon: `<svg viewBox="12 20 230 230" xmlns="http://www.w3.org/2000/svg">
      <path d="M50 40 L150 40 L190 80 L190 220 L50 220 Z" fill="none" stroke="currentColor" stroke-width="12" stroke-linejoin="round"/>
      <path d="M150 40 L150 80 L190 80" fill="none" stroke="currentColor" stroke-width="12" stroke-linejoin="round"/>
      <path d="M145 108 Q132 96 114 96 Q88 96 80 124 Q72 152 80 180 Q88 208 114 208 Q132 208 145 196" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round" />
      <line x1="74" y1="132" x2="124" y2="132" stroke="currentColor" stroke-width="11" stroke-linecap="round" />
      <line x1="70" y1="164" x2="120" y2="164" stroke="currentColor" stroke-width="11" stroke-linecap="round" />
    </svg>`,
  },
  {
    name: 'orders',
    theme: 'outline',
    icon: `<svg viewBox="12 20 230 230" xmlns="http://www.w3.org/2000/svg">
      <path d="M50 40 L150 40 L190 80 L190 220 L50 220 Z" fill="none" stroke="currentColor" stroke-width="12" stroke-linejoin="round" />
      <path d="M150 40 L150 80 L190 80" fill="none" stroke="currentColor" stroke-width="12" stroke-linejoin="round" />
      <path d="M78 118 L92 132 L116 106" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round" />
      <line x1="128" y1="120" x2="160" y2="120" stroke="currentColor" stroke-width="11" stroke-linecap="round" />
      <path d="M78 158 L92 172 L116 146" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round" />
      <line x1="128" y1="160" x2="160" y2="160" stroke="currentColor" stroke-width="11" stroke-linecap="round" />
    </svg>`,
  },
  {
    name: 'development',
    theme: 'outline',
    icon: `<svg viewBox="12 20 230 230" xmlns="http://www.w3.org/2000/svg">
      <path d="M50 40 L150 40 L190 80 L190 220 L50 220 Z" fill="none" stroke="currentColor" stroke-width="12" stroke-linejoin="round"/>
      <path d="M150 40 L150 80 L190 80" fill="none" stroke="currentColor" stroke-width="12" stroke-linejoin="round"/>
      <path d="M82 118 Q96 104 110 118 Q124 132 138 118 Q152 104 166 118" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M82 152 Q96 138 110 152 Q124 166 138 152 Q152 138 166 152" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M118 178 L118 198" stroke="currentColor" stroke-width="9" stroke-linecap="round" />
      <path d="M108 188 L128 188" stroke="currentColor" stroke-width="9" stroke-linecap="round" />
      <path d="M111 181 L125 195" stroke="currentColor" stroke-width="8" stroke-linecap="round" />
      <path d="M125 181 L111 195" stroke="currentColor" stroke-width="8" stroke-linecap="round"/>
    </svg>`,
  },
  {
    // Log out. ng-zorro's own `logout` glyph reads as an abstract bracket and
    // isn't recognised — this draws the literal metaphor instead: an open door
    // with an arrow leaving through it.
    name: 'sign-out',
    theme: 'outline',
    // Filled geometry rather than strokes: ant-design's "outline" icons are
    // solid paths shaped to look outlined, so a stroked SVG renders visibly
    // thinner and lighter than everything beside it.
    icon: `<svg viewBox="0 0 1024 1024" fill="currentColor">
      <rect x="144" y="144" width="72" height="736" rx="24"/>
      <rect x="144" y="144" width="416" height="72" rx="24"/>
      <rect x="144" y="808" width="416" height="72" rx="24"/>
      <rect x="432" y="476" width="304" height="72" rx="24"/>
      <path d="M672 356 L906 512 L672 668 Z"/>
    </svg>`,
  },
];
